import { render, staticRenderFns } from "./B2cAssessments.vue?vue&type=template&id=2a9ca29a&scoped=true"
import script from "./B2cAssessments.vue?vue&type=script&lang=js"
export * from "./B2cAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ca29a",
  null
  
)

export default component.exports